export default __webpack_public_path__ + "static/media/day.55f0516f.svg";